import { z } from 'zod';

const referrerRefSchema = z.object({
  kind: z.enum(['external_partner', 'internal_staff', 'stakeholder']),
  id: z.string().min(1, 'Referrer ID is required'),
  code: z.string().optional(),
});

export const referralSchema = z.object({
  type: z.enum(['in', 'out']),
  patientId: z.string().optional(),
  patientName: z.string().optional(),
  patientPhone: z.string()
    .regex(/^\d{10,15}$/, 'Phone must be 10-15 digits')
    .optional(),
  consentGiven: z.boolean().optional(),
  source: referrerRefSchema,
  toPartnerId: z.string().optional(),
  fromDoctorId: z.string().optional(),
  toSpecialty: z.string().optional(),
  reason: z.string().min(1, 'Reason is required'),
  notes: z.string().optional(),
  estimatedAmount: z.number().min(0).optional(),
});

export const publicReferralSchema = z.object({
  patientName: z.string().min(1, 'Patient name is required'),
  patientPhone: z.string()
    .regex(/^\d{10,15}$/, 'Phone must be 10-15 digits'),
  toSpecialty: z.string().optional(),
  reason: z.string().min(1, 'Reason is required'),
  consentGiven: z.boolean().refine(val => val === true, {
    message: 'Consent must be given for public referrals'
  }),
});

export type ReferralFormData = z.infer<typeof referralSchema>;
export type PublicReferralFormData = z.infer<typeof publicReferralSchema>;
